// src/App.tsx

import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import LoginPage from './pages/LoginPage';
import Home from './pages/Home';
import Curadoria from './pages/Curadoria';
import SheGpt from './pages/SheGpt';


/**
 * Componente de rota protegida
 * Redireciona para login se o usuário não estiver autenticado
 * Salva a rota original para redirecionamento após login
 */
const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { currentUser, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Carregando...</p>
        </div>
      </div>
    );
  }

  if (!currentUser) {
    // Salva a rota atual para redirecionamento após login
    const currentPath = window.location.pathname + window.location.search;
    return <Navigate to={`/login?redirect=${encodeURIComponent(currentPath)}`} replace />;
  }

  return <>{children}</>;
};

/**
 * Componente principal da aplicação
 */
function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Rota de login */}
          <Route path="/login" element={<LoginPage />} />

          {/* Rota principal - Home protegida */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            }
          />

          {/* Rotas dos módulos - protegidas */}
          <Route
            path="/curadoria"
            element={
              <ProtectedRoute>
                <Curadoria />
              </ProtectedRoute>
            }
          />

          <Route
            path="/shegpt"
            element={
              <ProtectedRoute>
                <SheGpt />
              </ProtectedRoute>
            }
          />

          {/* Rota de compatibilidade: redireciona /dashboard para /curadoria */}
          <Route path="/dashboard" element={<Navigate to="/curadoria" replace />} />

          {/* Rota 404 - Página não encontrada */}
          <Route
            path="*"
            element={
              <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <div className="text-center">
                  <h1 className="text-6xl font-bold text-gray-900 mb-4">404</h1>
                  <p className="text-xl text-gray-600 mb-8">Página não encontrada</p>
                  <a
                    href="/"
                    className="px-6 py-3 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition"
                  >
                    Voltar à Página Inicial
                  </a>
                </div>
              </div>
            }
          />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
